import { buildingLevel, buildingPlacementCost, type StoredResource } from "@zend/content";
import { MINUTE } from "../time.js";

export const MAX_SPEED_BONUS_PCT = 60;

export function upgradeCost(buildingId: string, toLevel: number): Record<StoredResource, number> {
  return { ...buildingLevel(buildingId, toLevel).cost };
}

/** Duration of an upgrade to `toLevel` with a speed bonus in percent (capped at 60 %). */
export function upgradeDurationMs(buildingId: string, toLevel: number, speedBonusPct: number): number {
  const base = buildingLevel(buildingId, toLevel).timeSec * 1000;
  return applySpeedBonus(base, speedBonusPct);
}

export function placementDurationMs(buildingId: string, speedBonusPct: number): number {
  return applySpeedBonus(buildingPlacementCost(buildingId).timeSec * 1000, speedBonusPct);
}

export function applySpeedBonus(baseMs: number, speedBonusPct: number): number {
  const bonus = Math.min(MAX_SPEED_BONUS_PCT, Math.max(0, speedBonusPct));
  return Math.round(baseMs * (1 - bonus / 100));
}

/** Instant finish costs the remaining whole minutes in Credits (D05). */
export function instantFinishPrice(remainingMs: number): number {
  if (remainingMs <= 0) return 0;
  return Math.ceil(remainingMs / MINUTE);
}

/** Applies a speedup of `minutes` to a timer; never earlier than `now`. */
export function applySpeedup(finishesAt: number, minutes: number, now: number): number {
  return Math.max(now, finishesAt - minutes * MINUTE);
}
